<template>
    <v-sheet>
      <v-form v-model="valid">
        <v-text-field prepend-icon="mdi-file-sign" required :rules="nonEmptyRules" v-model="appliactionTopic" :placeholder="this.$t('application_topic_label')"></v-text-field>
        <v-text-field prepend-icon="mdi-domain" v-model="companyName" :placeholder="this.$t('company_label')"></v-text-field>
        <v-select prepend-icon="mdi-map" required :items="provinces" v-model="province" :placeholder="this.$t('province_label')"></v-select>
        <v-text-field prepend-icon="mdi-mail" required :rules="emailRules" v-model="mail" :placeholder="this.$t('email_label')"></v-text-field>
        <v-text-field prepend-icon="mdi-human" v-model="nameSurname" :placeholder="this.$t('name_surname_label')"></v-text-field>
        <v-text-field prepend-icon="mdi-phone" v-model="phoneNumber" :placeholder="this.$t('phone_label')"></v-text-field>
        <v-btn :disabled="!valid" block @click="handleSubmitForm">{{$t('submit')}}</v-btn>
        <v-snackbar
            v-model="sendedMail"
            color="green"
            rounded="pill"
            >
            {{ $t('sended_mail') }}

            <template v-slot:action="{ attrs }">
                <v-btn
                color="white"
                text
                v-bind="attrs"
                @click="sendedMail = false"
                >
                {{$t('close')}}
                </v-btn>
            </template>
        </v-snackbar>
      </v-form>
    </v-sheet>
  </template>
  
  <script>
  import axios from "axios";
  import config from "@/config"
  
  export default {
  
    methods: {
      handleSubmitForm() {
        let message = `Person: ${this.nameSurname} \
        from ${this.province} with phone number: ${this.phoneNumber}\
        , topic: ${this.appliactionTopic} and company: ${this.companyName} require contact.`;
        let postData = {
          template: 'contact',
          title: "Require contact",
          topic: "Require contact",
          message: {message: message, mail: this.mail}
        }
        axios.post(config.MAIL_API_URL, postData)
            .then(response => console.debug('response', response))
            .then(this.sendedMail = true);
      }
    },
  
    data() {
      return {
        valid: false,
        emailRules: [
          v => !!v || this.$t('email_required'),
          v => /.+@.+/.test(v) || this.$t('email_not_valid'),
        ],
        nonEmptyRules: [
          v => !!v || this.$t('field_required')
        ],
        nameSurnameRules: [
            v => !!v || this.$t('name_surname_required'),
        ],
        phoneNumberRules: [
            v => !!v || this.$t('phone_required'),
        ],
        appliactionTopic: '',
        companyName: '',
        mail: '',
        nameSurname: '',
        phoneNumber: '',
        province: '',
        provinces: [
            "dolnośląskie",
            "kujawsko-pomorskie",
            "lubelskie",
            "lubuskie",
            "łódzkie",
            "małopolskie",
            "mazowieckie",
            "opolskie",
            "podkarpackie",
            "podlaskie",
            "pomorskie",
            "śląskie",
            "świętokrzyskie",
            "warmińsko-mazurskie",
            "wielkopolskie",
            "zachodniopomorskie"
        ],
        message: '',
        sendedMail: false,
      }
    },
  
  }
  </script>